import { Log } from '../AuxillaryService/Log';
import { $ } from '../../vendor/jquery';
import { videoInfoTemplate } from './video_info';

/**
 * @class
 * @todo document this
 */
var VideoDebugging = (function () {
    var self = {};
    var showInfo = false;
    var selector = '.announcement video';

    self.debugVideos = [];

    /**
     * @todo document this
     */
    self.initialize = function () {
        var currentVideoElements = self.debugVideos.map(function (debugVideo) {
            return debugVideo.videoElement;
        });
        var $newVideoElements = $(selector).filter(function () {
            return currentVideoElements.indexOf(this) === -1;
        });

        $newVideoElements.each(function () {
            var debugVideo = new DebugVideo(this);
            self.debugVideos.push(debugVideo);
        });
    };

    /**
     *
     * @todo document this
     */
    self.show = function () {
        showInfo = true;

        self.initialize(); // get new videos

        $.each(self.debugVideos, function (idx, debugVideo) {
            debugVideo.show();
        });

        return showInfo;
    };

    /**
     *
     * @todo document this
     */
    self.hide = function () {
        showInfo = false;

        $.each(self.debugVideos, function (idx, debugVideo) {
            debugVideo.hide();
        });

        return showInfo;
    };

    /**
     *
     * @todo document this
     */
    self.toggle = function () {
        showInfo = !showInfo;

        if (showInfo) {
            self.show();
        } else {
            self.hide();
        }

        return showInfo;
    };

    return self;
})();

/**
 * @class
 * @todo document this
 */
function DebugVideo(videoElement) {
    this._showInfo = false;

    this._mediaEvents = [
        'loadstart',
        'progress',
        'suspend',
        'abort',
        'error',
        'emptied',
        'stalled',
        'loadedmetadata',
        'loadeddata',
        'canplay',
        'canplaythrough',
        'playing',
        'waiting',
        'seeking',
        'seeked',
        'ended',
        'durationchange',
        'timeupdate',
        'play',
        'pause',
        'ratechange',
        'resize',
        'volumechange',
    ];

    this._mediaEventCounts = {};

    // it's a trick! needed in order to overcome the remove event listener (http://stackoverflow.com/a/33386309)
    this.updateInformation = this.updateInformation.bind(this);

    this.videoElement = videoElement;
    this.overlayElement = null;

    return this;
}

/**
 *
 * @todo document this
 */
DebugVideo.prototype.show = function () {
    this._showInfo = true;

    this.createOverlay();

    $.each(
        this._mediaEvents,
        function (idx, mediaEvent) {
            $(this.videoElement).on(mediaEvent, this.updateInformation);
        }.bind(this)
    );

    return this._showInfo;
};

/**
 *
 * @todo document this
 */
DebugVideo.prototype.hide = function () {
    this._showInfo = false;

    $.each(
        this._mediaEvents,
        function (idx, mediaEvent) {
            $(this.videoElement).off(mediaEvent, this.updateInformation);
        }.bind(this)
    );

    $(this.overlayElement).remove();
    this.overlayElement = null;

    return this._showInfo;
};

/**
 *
 * @todo document this
 */
DebugVideo.prototype.toggle = function () {
    this._showInfo = !this._showInfo;

    if (this._showInfo) {
        this.show();
    } else {
        this.hide();
    }

    return this._showInfo;
};

/**
 *
 * @todo document this
 */
DebugVideo.prototype.createOverlay = function () {
    if (!this.overlayElement) {
        Log.Info('Create Video Overlay', null, __fileline);

        var $videoInfoOverlay = $('<div class="videoInfoOverlay"></div>');
        this.overlayElement = $videoInfoOverlay.get(0);
        $(this.videoElement).after($videoInfoOverlay);

        var templateVariables = {
            mediaEvents: this._mediaEvents,
        };
        var hbHtml = videoInfoTemplate(templateVariables);

        $videoInfoOverlay.append(hbHtml);
    }

    return this.overlayElement;
};

/**
 *
 * @param {*} event
 * @todo document this
 */
DebugVideo.prototype.updateInformation = function (event) {
    var videoElement = this.videoElement;
    var $videoInfoOverlay = $(this.overlayElement);
    var widgetName = videoElement.dataset.widgetName || 'none';
    var videoName = videoElement.dataset.videoName || 'none';

    $videoInfoOverlay.find('.video-asset').html(widgetName + ' / ' + videoName);
    $videoInfoOverlay.find('.video-source').html(videoElement.src);
    $videoInfoOverlay.find('.event').html(event.type);

    if (event.type === 'timeupdate') {
        var $currentTimeElm = $videoInfoOverlay.find('.progress-info--current-time');
        let $progressElm = $videoInfoOverlay.find('.progress-info--current-time progress');

        try {
            $progressElm.attr('max', videoElement.duration);
            $progressElm.attr('value', videoElement.currentTime);
            $progressElm.html(videoElement.currentTime);

            $currentTimeElm.find('.progress-info--max').html(Math.round(videoElement.duration));
            $currentTimeElm
                .find('.progress-info--current')
                .html(Math.round(videoElement.currentTime));
        } catch (ex) {
            // The original developer failed to document what exception they
            // were trying to catch, so it is unknown why this try/catch block
            // is here.
        }
    }
    if (event.type === 'progress') {
        var $bufferingElm = $videoInfoOverlay.find('.progress-info--buffering');
        var lastRange = videoElement.buffered.length - 1;
        let $progressElm = $videoInfoOverlay.find('.progress-info--buffering progress');

        try {
            $progressElm.attr('max', videoElement.duration);
            $progressElm.attr('value', videoElement.buffered.end(lastRange));
            $progressElm.html(videoElement.buffered.length);

            $bufferingElm.find('.progress-info--max').html(Math.round(videoElement.duration));
            $bufferingElm
                .find('.progress-info--current')
                .html(Math.round(videoElement.buffered.end(lastRange)));
        } catch (ex) {
            // The original developer failed to document what exception they
            // were trying to catch, so it is unknown why this try/catch block
            // is here.
        }
    }

    if (this._mediaEventCounts[event.type] === undefined) {
        this._mediaEventCounts[event.type] = {
            count: 0,
            timeStamp: 0,
        };
    }

    this._mediaEventCounts[event.type].count++;
    this._mediaEventCounts[event.type].timeStamp = event.timeStamp;

    $videoInfoOverlay
        .find('.media-event--' + event.type + ' .media-event--count')
        .html(this._mediaEventCounts[event.type].count);
    $videoInfoOverlay
        .find('.media-event--' + event.type + ' .media-event--timestamp')
        .html(Math.round(event.timeStamp));

    // move latest event to end of list
    var $mediaEventElm = $videoInfoOverlay.find('.media-event--' + event.type);
    $mediaEventElm.parent().append($mediaEventElm);
    $mediaEventElm.addClass('media-event--updated');
};

export { VideoDebugging as VideoInfo, DebugVideo as VideoInfoElement };
